module.exports = __webpack_public_path__ + "img/img-3.3bd91e3f.jpg";